import React, { useState } from 'react';
import { SelectWrapper } from "./orderReportsStyled";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import MultiSelect from "web/components/MultiSelect";
import { orderStatusList, pickupStatusList, clearButtonStyle, applyButtonStyle } from './Constants'


export default ({ isOpen, orderFilterState, handleFilterStateChange, handleStatusChange, toggle, callBack, filterCities, states, statusList }) => {
    const [storeInitialFilterData, setStoreInitialFitlerData] = useState(orderFilterState)

    return (
        <div className='recurranceModal'>
            <Modal isOpen={isOpen} centered={true} size="md">
                <ModalHeader toggle={() => { toggle(!isOpen) }}>
                    <h6 style={{ color: '#0A5587', fontFamily: 'latobold' }}>Filters</h6>
                </ModalHeader>
                <ModalBody>
                    <div className='filterWrapper'>
                        {orderFilterState.requestType === 'Delivery' &&
                            <div>
                                <p>Order Type</p>
                                <SelectWrapper>
                                    <select
                                        id="orderType"
                                        value={orderFilterState.orderType}
                                        onChange={handleFilterStateChange}
                                    >
                                        <option value="BOTH">Both</option>
                                        <option value="BUYER">Buying</option>
                                        <option value="SELLER">Selling</option>
                                    </select>
                                </SelectWrapper>
                            </div>
                        }
                        <div>
                            <p>State</p>
                            <SelectWrapper>
                                <select
                                    id="state"
                                    value={orderFilterState.state}
                                    onChange={handleFilterStateChange}
                                >
                                    <option value="">All</option>
                                    {states.map((data, index) => {
                                        return <option value={data.value}>{data.label}</option>;
                                    })}
                                </select>
                            </SelectWrapper>
                        </div>
                        <div>
                            <p>City</p>
                            <SelectWrapper>
                                <select
                                    id="city"
                                    value={orderFilterState.city}
                                    onChange={handleFilterStateChange}
                                >
                                    <option value="">All</option>
                                    {filterCities.map((data, index) => {
                                        return <option value={data.label}>{data.label}</option>;
                                    })}
                                </select>
                            </SelectWrapper>
                        </div>
                        <div>
                            <p>Status</p>
                            <SelectWrapper>
                                <MultiSelect
                                    name="pickupOrderStatus"
                                    returnValue='true'
                                    data={orderFilterState.requestType === 'Delivery' ? orderStatusList : pickupStatusList}
                                    multiSelectVal={orderFilterState.status}
                                    defaultValueArr={orderFilterState.status}
                                    isSearchable={false}
                                    onChangeHandler={(data) => handleStatusChange(data)}
                                />
                            </SelectWrapper>
                        </div>
                        <div>
                            <p>Date</p>
                            <SelectWrapper>
                                <input
                                    type="date"
                                    max={orderFilterState.toDate}
                                    id="fromDate"
                                    value={orderFilterState.fromDate}
                                    onChange={handleFilterStateChange}
                                />
                            </SelectWrapper>
                        </div>
                        <div>
                            <p>To</p>
                            <SelectWrapper>
                                <input
                                    type="date"
                                    min={orderFilterState.fromDate}
                                    id="toDate"
                                    value={orderFilterState.toDate}
                                    onChange={handleFilterStateChange}
                                />
                            </SelectWrapper>
                        </div>
                    </div>
                </ModalBody>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', margin: '5px  20px 25px 20px' }}>
                    <button style={clearButtonStyle}
                        onClick={() => callBack('clear', storeInitialFilterData)}>
                        Clear all
                    </button>
                    <button style={applyButtonStyle}
                        onClick={() => callBack('apply')}>
                        Apply
                    </button>
                </div>
            </Modal>
        </div>
    );
};
